import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/i18n/SiteContext";

export default function NotFoundPage() {
  const { t } = useSite();
  return (
    <div className="pt-44 pb-32 px-6 text-center" data-testid="not-found-page">
      <p className="font-serif text-7xl text-sea">404</p>
      <h1 className="font-serif text-3xl text-ocean mt-4">{t("notFound.title")}</h1>
      <Link to="/" className="inline-block mt-8 px-8 py-3.5 bg-ocean text-ivory text-sm uppercase tracking-wider rounded-xl" data-testid="not-found-home">{t("notFound.back")}</Link>
    </div>
  );
}
